/**
 * Active-store store — EGASI uchun "joriy do'kon" tanlovi.
 *
 * EGASI bir nechta do'konga ega. Tanlangan do'kon `X-Active-Store-Id` header
 * orqali serverga yuboriladi (api-client) va server RLS'ni o'sha do'konga
 * scope qiladi. `null` = "Hamma do'kon" (header yuborilmaydi → bypass).
 *
 * Default: birinchi kirishda asosiy do'kon (ensureDefault). localStorage'da
 * saqlanadi. ADMIN/XODIM uchun ahamiyatsiz (server header'ni e'tiborsiz qoldiradi).
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { apiClient } from '@/shared/lib/api-client';

interface ActiveStoreState {
  /** null = "Hamma do'kon" (barcha do'kon birga) */
  activeStoreId: string | null;
  /** birinchi default o'rnatildimi (qayta-qayta override qilmaslik uchun) */
  initialized: boolean;
  /** Do'kon tanlash (null = Hamma do'kon) */
  setActiveStore: (id: string | null) => void;
  /** Birinchi marta default do'konni o'rnatish (asosiy do'kon id) */
  ensureDefault: (defaultStoreId: string | null) => void;
}

export const useActiveStore = create<ActiveStoreState>()(
  persist(
    (set, get) => ({
      activeStoreId: null,
      initialized: false,
      setActiveStore: (id) => {
        apiClient.setActiveStoreId(id);
        set({ activeStoreId: id, initialized: true });
      },
      ensureDefault: (defaultStoreId) => {
        if (get().initialized) return;
        apiClient.setActiveStoreId(defaultStoreId);
        set({ activeStoreId: defaultStoreId, initialized: true });
      },
    }),
    {
      name: 'avtofix-active-store',
      onRehydrateStorage: () => (state) => {
        // Sahifa yangilanganda apiClient'ga joriy do'konni qaytadan yuklash
        if (state) apiClient.setActiveStoreId(state.activeStoreId);
      },
    },
  ),
);
